<template>
    <DModal
        :title="__('customers.contracts.domain_contact_details.edit_domain_contact_details')"
        is-confirm
        :show="showModal"
        :is-awaiting-validation="true"
        @confirm="confirmForm"
        @close="closeModal"
    >
        <div style="padding: 20px;">
            <DFieldLoading
                v-if="isLoading"
                :is-loading="isLoading"
                is-big
                class="my-4 d-flex justify-content-center"
            />
            <DForm
                v-else
                @submit.prevent=""
            >
                <DFormRow
                    :label="__('customers.contracts.domain_contact_details.use_customer_data')"
                    :error="errorsData.uses_customer_data"
                    is-required
                >
                    <DSwitch
                        v-model="form.uses_customer_data"
                        color="success"
                        variant="3d"
                    />
                </DFormRow>
                <DFormRow
                    v-if="form.uses_customer_data === false"
                    :label="__('customers.contracts.domain_contact_details.firstname')"
                    :error="errorsData.firstname"
                    is-required
                >
                    <DInput
                        id="firstname"
                        v-model="form.firstname"
                        :placeholder="__('customers.contracts.domain_contact_details.firstname')"
                    />
                </DFormRow>
                <DFormRow
                    v-if="form.uses_customer_data === false"
                    :label="__('customers.contracts.domain_contact_details.lastname')"
                    :error="errorsData.lastname"
                    is-required
                >
                    <DInput
                        id="lastname"
                        v-model="form.lastname"
                        :placeholder="__('customers.contracts.domain_contact_details.lastname')"
                    />
                </DFormRow>
                <DFormRow
                    v-if="form.uses_customer_data === false"
                    :label="__('customers.contracts.domain_contact_details.company')"
                    :error="errorsData.company"
                >
                    <DInput
                        id="company"
                        v-model="form.company"
                        :placeholder="__('customers.contracts.domain_contact_details.company')"
                    />
                </DFormRow>
                <DFormRow
                    v-if="form.uses_customer_data === false"
                    :label="__('customers.contracts.domain_contact_details.email')"
                    :error="errorsData.email"
                    is-required
                >
                    <DInput
                        id="email"
                        v-model="form.email"
                        :placeholder="__('customers.contracts.domain_contact_details.email')"
                    />
                </DFormRow>
                <DFormRow
                    v-if="form.uses_customer_data === false"
                    :label="__('customers.contracts.domain_contact_details.phone')"
                    :error="errorsData.phone"
                    is-required
                >
                    <DPhoneInput
                        id="phone"
                        v-model="form.phone"
                        :phone-country-code-placeholder="phoneCountryCodePlaceholder"
                    />
                </DFormRow>
                <DFormRow
                    v-if="form.uses_customer_data === false"
                    :label="__('customers.contracts.domain_contact_details.fax')"
                    :error="errorsData.fax"
                >
                    <DPhoneInput
                        id="fax"
                        v-model="form.fax"
                        :phone-country-code-placeholder="phoneCountryCodePlaceholder"
                    />
                </DFormRow>
                <DFormRow
                    v-if="form.uses_customer_data === false"
                    :label="__('customers.contracts.domain_contact_details.address1')"
                    :error="errorsData.address1"
                    is-required
                >
                    <DInput
                        id="address1"
                        v-model="form.address1"
                        :placeholder="__('customers.contracts.domain_contact_details.address1')"
                    />
                </DFormRow>
                <DFormRow
                    v-if="form.uses_customer_data === false"
                    :label="__('customers.contracts.domain_contact_details.address2')"
                    :error="errorsData.address2"
                >
                    <DInput
                        id="address2"
                        v-model="form.address2"
                        :placeholder="__('customers.contracts.domain_contact_details.address2')"
                    />
                </DFormRow>
                <DFormRow
                    v-if="form.uses_customer_data === false"
                    :label="__('customers.contracts.domain_contact_details.postal_code')"
                    :error="errorsData.postal_code"
                    is-required
                >
                    <DInput
                        id="postal_code"
                        v-model="form.postal_code"
                        :placeholder="__('customers.contracts.domain_contact_details.postal_code')"
                    />
                </DFormRow>
                <DFormRow
                    v-if="form.uses_customer_data === false"
                    :label="__('customers.contracts.domain_contact_details.city')"
                    :error="errorsData.city"
                    is-required
                >
                    <DInput
                        id="city"
                        v-model="form.city"
                        :placeholder="__('customers.contracts.domain_contact_details.city')"
                    />
                </DFormRow>
                <DFormRow
                    v-if="form.uses_customer_data === false"
                    :label="__('customers.contracts.domain_contact_details.country_code')"
                    :error="errorsData.country_code"
                    is-required
                >
                    <DSelect
                        id="country_code"
                        v-model="form.country_code"
                        :options="countries"
                    />
                </DFormRow>
                <DFormRow
                    v-if="
                        form.uses_customer_data === false &&
                            customer.customer_type !== 'privat' &&
                            customer.business_id_norway &&
                            getTld(contract.domain.name) === 'no'
                    "
                    :label="__('customers.contracts.domain_contact_details.business_id_norway')"
                    :error="errorsData.business_id_norway"
                    is-required
                >
                    <DInput
                        id="business_id_norway"
                        v-model="form.business_id_norway"
                        :placeholder="__('customers.contracts.domain_contact_details.business_id_norway')"
                    />
                </DFormRow>
                <DFormRow
                    v-if="
                        !form.uses_customer_data &&
                            customer.customer_type === 'privat' &&
                            customer.personal_id_norway &&
                            getTld(contract.domain.name) === 'no'
                    "
                    :label="__('customers.contracts.domain_contact_details.personal_id_norway')"
                    :error="errorsData.personal_id_norway"
                    is-required
                >
                    <DInput
                        id="personal_id_norway"
                        v-model="form.personal_id_norway"
                        :placeholder="__('customers.contracts.domain_contact_details.personal_id_norway')"
                    />
                </DFormRow>
                <div
                    v-if="form.uses_customer_data === false"
                >
                    <DRow
                        v-for="(field, index) in form.custom_fields"
                        :key="'custom_field_' + index"
                        :label="field.key"
                        class="custom-field"
                    >
                        <DCol lg="4">
                            <DInput
                                :id="'custom_field_key_'+index"
                                v-model="form.custom_fields[index].key"
                                :invalid="errorsData['custom_fields.'+index+'.key']"
                                :placeholder="__('customers.contracts.domain_contact_details.key')"
                            />
                            <div class="custom-field-error py-1">
                                {{ errorsData['custom_fields.'+index+'.key'] }}
                            </div>
                        </DCol>
                        <DCol lg="6">
                            <DInput
                                :id="'custom_field_value_'+index"
                                v-model="form.custom_fields[index].value"
                                :invalid="errorsData['custom_fields.'+index+'.value']"
                                :placeholder="__('customers.contracts.domain_contact_details.value')"
                            />
                            <div class="custom-field-error py-1">
                                {{ errorsData['custom_fields.'+index+'.value'] }}
                            </div>
                        </DCol>
                        <DCol lg="1">
                            <DButton
                                mini
                                color="danger"
                                icon="delete"
                                @click="removeCustomField(index)"
                            />
                        </DCol>
                    </DRow>
                    <div class="d-flex justify-content-center">
                        <DButton
                            color="primary"
                            icon="plus"
                            class="rounded-circle plus-icon"
                            @click="addCustomField"
                        />
                    </div>
                </div>
            </DForm>
        </div>
    </DModal>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { ref } from 'vue'
import DFieldLoading from '~@/Components/Common/DFieldLoading'
import { getCountries } from '~@/Composables/dropdowns/settings/countries.js'

// Basic
const props = defineProps({
    contract: {
        type: Object,
        default: () => { return {} }
    },
    customer: {
        type: Object,
        default: () => { return {} }
    },
    showModal: {
        type: Boolean,
        default: false
    },

    errors: {
        type: Object,
        default: () => { return {} }
    },
    phoneCountryCodePlaceholder: {
        type: String,
        default: ''
    }
})
const emit = defineEmits(['close-modal'])

const errorsData = ref(props.errors)

const closeModal = () => {
    emit('close-modal')
}

// Countries dropdown
const { isLoading, countries } = getCountries()

// Form
const form = useForm({
    firstname: props.contract.domain_owner?.firstname ?? null,
    lastname: props.contract.domain_owner?.lastname ?? null,
    email: props.contract.domain_owner?.email ?? null,
    company: props.contract.domain_owner?.company ?? null,
    phone: props.contract.domain_owner?.phone ?? null,
    fax: props.contract.domain_owner?.fax ?? null,
    address1: props.contract.domain_owner?.address1 ?? null,
    address2: props.contract.domain_owner?.address2 ?? null,
    postal_code: props.contract.domain_owner?.postal_code ?? null,
    city: props.contract.domain_owner?.city ?? null,
    country_code: props.contract.domain_owner?.country_code ?? null,
    uses_customer_data: props.contract.domain_owner?.uses_customer_data ?? true,
    personal_id_norway: getPersonalIdNorway(),
    business_id_norway: getBusinessIdNorway(),
    custom_fields: props.contract.domain_owner?.custom_fields ?? []
})

const confirmForm = () => {
    form.post(route('customers.customers.contracts.update-domain-contact-details', {
        customer: props.contract.customer_id,
        contract: props.contract.id
    }), {
        onSuccess: () => {
            emit('close-modal')
        },
        onError: (error) => {
            errorsData.value = error
        }
    })
}

// Custom fields
function removeCustomField (index) {
    form.custom_fields.splice(index, 1)
}

function addCustomField () {
    form.custom_fields[form.custom_fields.length] = {
        key: null,
        value: null
    }
}

function getTld (domainName) {
    const domainParts = domainName.split('.')

    if (domainParts.length > 2) {
        return domainParts.slice(-2).join('.').toLowerCase()
    }

    const lastPart = domainParts.pop()
    return lastPart ? lastPart.toLowerCase() : ''
}

function getPersonalIdNorway () {
    if (!props.contract?.domain?.name) {
        return null
    }

    if (getTld(props.contract.domain.name) === 'no') {
        return props.contract.domain_owner?.personal_id_norway ?? props.customer.personal_id_norway
    }

    return null
}

function getBusinessIdNorway () {
    if (!props.contract?.domain?.name) {
        return null
    }

    if (getTld(props.contract.domain.name) === 'no') {
        return props.contract.domain_owner?.business_id_norway ?? props.customer.business_id_norway
    }

    return null
}

</script>

<style>
.plus-icon {
    min-height: 45px;
}
.custom-field {
    margin-bottom: 25px;
}
.custom-field-error {
    font-size: 12px;
    color: var(--colorDanger);
}
</style>
